import React from 'react';
import CenteredContent from '../CenteredContent';

import './LegalDocument.scss';

function LegalDocument(props) {
  const { children, title } = props;

  return (
    <CenteredContent className="legal-document">
      <div className="legal-document__content">
        <div className="legal-document__title">{title}</div>
        <div className="legal-document__body">{children}</div>
      </div>
    </CenteredContent>
  );
}

export default LegalDocument;
